import { render, staticRenderFns } from "./MicroserviceFilter.vue?vue&type=template&id=79efeca4&"
import script from "./MicroserviceFilter.vue?vue&type=script&lang=js&"
export * from "./MicroserviceFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports